import { StageInterface } from "@/v2/types/StageInterface";

const calculateTotalLotsByStatus = (stages: StageInterface[]) => {
  if (!stages || !Array.isArray(stages) || stages.length === 0) {
    return {
      total: 0,
      available: 0,
      hold: 0,
      underContract: 0,
      settled: 0,
      notReleased: 0,
      unconditional: 0,
    };
  }

  return stages.reduce(
    (totals, stage) => {
      totals.total += stage.counts.total;
      totals.available += stage.counts.available;
      totals.hold += stage.counts.hold;
      totals.underContract += stage.counts.underContract;
      totals.unconditional += stage.counts.unconditional;
      totals.settled += stage.counts.settled;
      totals.notReleased += stage.counts.notReleased;
      return totals;
    },
    {
      total: 0,
      available: 0,
      hold: 0,
      underContract: 0,
      settled: 0,
      notReleased: 0,
      unconditional: 0,
    }
  );
};

export default calculateTotalLotsByStatus;
